import React, { useEffect, useState } from "react";
import axios from "axios";
import { parseISO, format } from "date-fns";
import config from "../../util/config";
import { Spinner } from "@material-tailwind/react";
import { es } from "date-fns/locale";

const MiDisponibilidadProfileYiyerPublic = ({ userId }) => {
  const [horarios, setHorarios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHorarios = async () => {
      if (userId) {
        try {
          const response = await axios.get(
            `${config.URL_HOST}/midisponibilidad/${userId}`
          );
          setHorarios(response.data);
          setLoading(false);
        } catch (error) {
          console.error("Error al cargar los datos:", error);
        }
      }
    };

    fetchHorarios();
  }, [userId]);

  

  const currentDate = new Date();
  const currentDateString = format(currentDate, "yyyy-MM-dd");

  const futureHorarios = horarios.filter((horario) => {
    const horarioDate = format(parseISO(horario.date), "yyyy-MM-dd");
    return horarioDate >= currentDateString;
  });

  const horarioElements = futureHorarios.map((horario) => (
    <tr key={horario.id} className="text-center text-xs md:text-sm text-gray-600">
      <td className="border p-1">
        {format(parseISO(horario.date), "dd 'de' MMMM 'de' yyyy", {
          locale: es,
        })}
      </td>
      <td className="border p-1">{horario.start_time}</td>
      <td className="border p-1">{horario.end_time}</td>
    </tr>
  ));

  return (
    <div className="w-full">
      {loading ? ( 
        <>
          <Spinner className="mx-auto h-10 w-10" />
        </>
      ) : (
        <div className="flex flex-col">
          <table className="w-full border-collapse border mt-4 mx-auto">
            <thead>
              <tr className="bg-gray-200 text-xs uppercase">
                <th className="border p-2">Fecha</th>
                <th className="border p-2">Desde</th>
                <th className="border p-2">Hasta</th>
              </tr>
            </thead>
            <tbody>
              {horarioElements.length > 0 ? (
                horarioElements
              ) : (
                <tr>
                  <td colSpan="4" className="text-center p-1 text-xs">
                    No hay horarios guardados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MiDisponibilidadProfileYiyerPublic;
